/**
 * MENTOR EVENTS — Mock Data
 * Meetup-style events created by mentors.
 * Duration is always a number (minutes).
 */

// Node.js Security Workshop — Amar's past completed event (also in the public feed)
const EV_OLD1 = {
  id: 'ev-old1',
  title: 'Node.js Security Workshop',
  description: 'Hands-on workshop covering common Node.js security pitfalls: SQL injection, XSS, CSRF, insecure dependencies, and JWT hardening. Bring your laptop.',
  mentor: 'Amar Krishnan', mentorId: 1, mentorAvatar: 'Amar', mentorBg: '16a34a', mentorRole: 'Ex-Google Engineer',
  date: 'Feb 12, 2025', time: '7:00 PM IST', duration: 90,
  type: 'workshop',
  tags: ['Node.js', 'Security', 'Backend'],
  priceINR: 0,
  maxAttendees: 100, registeredCount: 62,
  meetingPlatform: 'zoom', meetingLink: '',
  status: 'completed',
  socialLinks: { linkedin: '', twitter: '' },
  recordingUrl: '',
  rating: 4.8, totalRatings: 58,
  testimonials: [
    { name: 'Karan D.', comment: 'Eye-opening session. Fixed three security holes in my own app the same night.', rating: 5 },
  ],
};

export const EVENTS = [
  {
    id: 'ev1',
    title: 'React Performance Masterclass',
    description: 'Deep dive into React performance optimization: memo, useMemo, useCallback, code splitting, lazy loading, and Profiler. Live coding with Q&A.',
    mentor: 'Amar Krishnan', mentorId: 1, mentorAvatar: 'Amar', mentorBg: '16a34a', mentorRole: 'Ex-Google Engineer',
    date: 'Mar 10, 2025', time: '7:00 PM IST', duration: 90, // minutes
    type: 'workshop', // workshop | webinar | qa | hackathon | office_hours
    tags: ['React', 'Performance', 'Frontend'],
    priceINR: 0, // 0 = free
    maxAttendees: 100, registeredCount: 87,
    meetingPlatform: 'zoom', meetingLink: 'https://zoom.us/j/1234567890',
    status: 'upcoming', // upcoming | live | completed | cancelled
    socialLinks: {
      linkedin: 'https://linkedin.com/posts/amar-react-perf',
      twitter: 'https://twitter.com/intent/tweet?text=Join+React+Masterclass',
    },
    recordingUrl: '',
    rating: null, totalRatings: 0,
    testimonials: [],
  },
  {
    id: 'ev2',
    title: 'Breaking into AI/ML — Roadmap for 2025',
    description: 'Everything you need to know to start an ML career in 2025. Skills, timeline, interview prep, and portfolio projects. Free session — open to all.',
    mentor: 'Siti Nabilah', mentorId: 2, mentorAvatar: 'Siti', mentorBg: '2563eb', mentorRole: 'ML Engineer @ Shopee',
    date: 'Mar 15, 2025', time: '3:00 PM MYT', duration: 60,
    type: 'webinar',
    tags: ['AI', 'ML', 'Career'],
    priceINR: 0,
    maxAttendees: 200, registeredCount: 164,
    meetingPlatform: 'meet', meetingLink: 'https://meet.google.com/abc-defg-hij',
    status: 'upcoming',
    socialLinks: { linkedin: '', twitter: '' },
    recordingUrl: '',
    rating: null, totalRatings: 0,
    testimonials: [],
  },
  {
    id: 'ev3',
    title: 'System Design Office Hours — Mock Interviews',
    description: 'Live system design mock interviews open to all. Volunteers get grilled, everyone learns. FAANG-level questions — design YouTube, Uber, WhatsApp.',
    mentor: 'Amar Krishnan', mentorId: 1, mentorAvatar: 'Amar', mentorBg: '16a34a', mentorRole: 'Ex-Google Engineer',
    date: 'Mar 22, 2025', time: '8:00 PM IST', duration: 120,
    type: 'office_hours',
    tags: ['System Design', 'FAANG', 'Interviews'],
    priceINR: 499,
    maxAttendees: 30, registeredCount: 28,
    meetingPlatform: 'zoom', meetingLink: 'https://zoom.us/j/9876543210',
    status: 'upcoming',
    socialLinks: { linkedin: '', twitter: '' },
    recordingUrl: '',
    rating: null, totalRatings: 0,
    testimonials: [],
  },
  {
    id: 'ev4',
    title: 'Figma Crash Course — Design Your First App in 2 Hours',
    description: 'Beginners only! We will design a mobile app from scratch together. From wireframes to high-fidelity UI in one session. Bring your laptop.',
    mentor: 'Meera Jayaram', mentorId: 6, mentorAvatar: 'Meera', mentorBg: 'd97706', mentorRole: 'Senior UX Designer @ Axiata',
    date: 'Mar 5, 2025', time: '6:00 PM IST', duration: 120,
    type: 'workshop',
    tags: ['Figma', 'UI/UX', 'Beginner'],
    priceINR: 0,
    maxAttendees: 50, registeredCount: 50, // full
    meetingPlatform: 'teams', meetingLink: 'https://teams.microsoft.com/l/meetup-join/xyz',
    status: 'completed',
    socialLinks: { linkedin: '', twitter: '' },
    recordingUrl: 'https://youtube.com/watch?v=example',
    rating: 4.9, totalRatings: 44,
    testimonials: [
      { name: 'Isma Johari', comment: 'Best design session I have attended. Meera is an incredible teacher!', rating: 5 },
      { name: 'Preethi R', comment: 'Went from zero Figma knowledge to designing a real app. Incredible.', rating: 5 },
    ],
  },
  EV_OLD1,
];
